<template>
  <div>
    <ul class="nav nav-tabs" style="margin-bottom: 15px">
      <li
        v-show="!tab.hide"
        v-for="tab in tabs"
        :key="tab.key"
        :class="{ active: tabSelected === tab.key }"
      >
        <a href="#" @click.prevent="selectedTab(tab)" style="font-size: 11px">
          {{ tab.value | upper }}
        </a>
      </li>
    </ul>
    <slot :tabSelected="tabSelected" />
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tabSelected: null,
    };
  },
  created() {
    this.tabSelected = this.tabs[0].key;
  },
  methods: {
    selectedTab({ key }) {
      this.tabSelected = key;
      this.$emit("tab-selected", key);
    },
  },
};
</script>
